import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=3dfc87bb&scoped=true"
import script from "./PaymentPix.vue?vue&type=script&lang=js"
export * from "./PaymentPix.vue?vue&type=script&lang=js"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=3dfc87bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc87bb",
  null
  
)

export default component.exports